import type { Moment } from 'moment';
import moment from 'moment';
import type { TaxPeriodValue } from '@nxsys/components/AppTaxPeriodDropdown';
import type {
  GetAnalyticsPensionDocumentParams,
  GetAnalyticsPayrollCostParams,
} from '@nxsys/store/slices/analytics/types';
import { PayFrequencyValue } from '@nxsys/components/AppPayFrequencySelect/type';

const getDefaultDateRange = (): [Moment, Moment] => [
  moment.utc().startOf('month'),
  moment.utc().endOf('month'),
];

const defaultDateRange = getDefaultDateRange();

export const buildAnalyticsFilterParams = (
  dateRange?: [Moment | null, Moment | null] | null,
  taxPeriod?: TaxPeriodValue | undefined,
  payFrequencies?: PayFrequencyValue,
  employerIds?: string[],
): GetAnalyticsPensionDocumentParams & GetAnalyticsPayrollCostParams => {
  const base: GetAnalyticsPensionDocumentParams &
    GetAnalyticsPayrollCostParams = {};
  if (dateRange && dateRange[0] && dateRange[1]) {
    base.dateFrom = dateRange[0].format('YYYY-MM-DD');
    base.dateTo = dateRange[1].format('YYYY-MM-DD');
  } else if (
    taxPeriod &&
    taxPeriod.taxYear !== undefined &&
    taxPeriod.taxPeriodFrom !== undefined &&
    taxPeriod.taxPeriodTo !== undefined
  ) {
    base.taxYear = String(taxPeriod.taxYear);
    base.taxPeriodFrom = String(taxPeriod.taxPeriodFrom);
    base.taxPeriodTo = String(taxPeriod.taxPeriodTo);
  } else {
    base.dateFrom = defaultDateRange[0].format('YYYY-MM-DD');
    base.dateTo = defaultDateRange[1].format('YYYY-MM-DD');
  }
  if (payFrequencies) {
    base.payFrequencies = payFrequencies.toString();
  }
  if (employerIds?.length) {
    base.employerIds = employerIds.join(',');
  }
  return base;
};

export { defaultDateRange };
